import BaseApiService from './BaseApiService.js';

class AuthService extends BaseApiService {
  // ✅ Admin/College Login
  async login(orgId, password, username = '') {
    return this.makeRequest('/api/admin/college/login', {
      method: 'POST',
      body: JSON.stringify({ orgId, password, username }),
    });
  }

  // ✅ Teacher Login
  async teacherLogin(orgId, teacherId, password) {
    return this.makeRequest('/api/teacher/login', {
      method: 'POST',
      body: JSON.stringify({ orgId, teacherId, password }),
    });
  }

  // ✅ Logout (clear token)
  logout() {
    this.removeToken();
    return Promise.resolve({ success: true, message: 'Logged out successfully' });
  }

  // ✅ Check if user is authenticated
  isAuthenticated() {
    return !!this.getToken();
  }

  // ✅ Request password reset OTP
  async forgotPassword(orgId, email) {
    return this.makeRequest('/api/admin/college/forgot-password', {
      method: 'POST',
      body: JSON.stringify({ orgId, email }),
    });
  }

  // ✅ Reset password using OTP
  async resetPassword(orgId, email, otp, newPassword) {
    return this.makeRequest('/api/admin/college/reset-password', {
      method: 'POST',
      body: JSON.stringify({ orgId, email, otp, newPassword }),
    });
  }

  // ✅ Update Admin/College Profile Info
  async updateAdminProfile(updateData) {
    return this.makeRequest('/api/admin/college/profile', {
      method: 'PUT',
      body: JSON.stringify(updateData),
    });
  }

  // ✅ Get Admin/College Profile Info (Secure GET)
  async getAdminProfile() {
    return this.makeRequest('/api/admin/college/profile', {
      method: 'GET',
    });
  }
}

// ✅ Export single instance
const authService = new AuthService();
export default authService;
